import { Project } from './types';

export const projectMock: Project = {
  name: ``,
  slug: ``,
  description: {
    description: ``,
  },
  thumbnailImage: {
    description: ``,
    gatsbyImageData: {
      height: 60,
      width: 60,
      layout: `fullWidth`,
      placeholder: {
        fallback: ``,
      },
      images: {
        fallback: {
          sizes: ``,
          src: ``,
          srcSet: ``,
        },
        sources: [
          {
            sizes: ``,
            srcSet: ``,
            type: ``,
          },
        ],
      },
    },
  },
};
